import React from "react";
import "../HomePlatform.css";

import {
  FiShoppingCart,
  FiCreditCard,
  FiTruck,
  FiRefreshCw,
  FiGrid,
  FiHeadphones,
} from "react-icons/fi";

const platformData = [
  {
    icon: <FiShoppingCart />,
    title: "E-Commerce Solutions",
    description:
      "Build secure, scalable, and high-performing online stores tailored to your business needs.",
  },
  {
    icon: <FiCreditCard />,
    title: "Secure Payment Integration",
    description:
      "Integrate trusted payment gateways for fast, secure, and seamless online transactions.",
  },
  {
    icon: <FiTruck />,
    title: "Order & Delivery Management",
    description:
      "Simplify order processing, shipment tracking, and delivery management with smart solutions.",
  },
  {
    icon: <FiRefreshCw />,
    title: "Inventory & Returns",
    description:
      "Efficiently manage inventory, product stock, and hassle-free return workflows.",
  },
  {
    icon: <FiGrid />,
    title: "Business Dashboard",
    description:
      "Access real-time sales reports, analytics, customer insights, and business performance.",
  },
  {
    icon: <FiHeadphones />,
    title: "Customer Support",
    description:
      "Deliver exceptional customer experiences with integrated support and communication tools.",
  },
];

const HomePlatform = () => {
  return (
    <section className="home-platform">

      <div className="container">

        {/* Heading */}

        <div className="platform-heading">

          <span className="platform-badge">
            Our Capabilities
          </span>

          <h2>
            Smart Digital Solutions for
            <span> Modern Businesses</span>
          </h2>

          <p>
            At Kishancart Digital, we create innovative digital solutions that
            help businesses establish, manage, and grow their online presence.
            Our services are designed to improve efficiency, enhance customer
            experiences, and accelerate business growth through modern
            technology.
          </p>

        </div>

        {/* Cards */}

        <div className="platform-grid">

          {platformData.map((item, index) => (

            <div className="platform-card" key={index}>

              <div className="platform-icon">
                {item.icon}
              </div>

              <h3>{item.title}</h3>

              <p>{item.description}</p>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
};

export default HomePlatform;